import { render } from "./TestSurvey.vue?vue&type=template&id=5832d870&scoped=true"
import script from "./TestSurvey.vue?vue&type=script&lang=js"
export * from "./TestSurvey.vue?vue&type=script&lang=js"

import "./TestSurvey.vue?vue&type=style&index=0&id=5832d870&scoped=true&lang=css"

import exportComponent from "I:\\JavaWork\\Recruit\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5832d870"]])

export default __exports__